import React, { useState, useEffect, useRef } from "react";

// state management
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  uploadFileDataV1,
  updateBulkUploadFileUploader,
  updateBulkUploadFormData,
  startBulkProcess,
  updateBulkProcessing,
  resetBulkUploadData,
} from "../../actions/bulkProcessAction";

// common
import moment from "moment";
import { makeRequestAuth } from "../../utils/globals";
import { NotificationManager } from "react-notifications";
import ActionModal from "../../components/Modals/ActionModal";
import MessageModal from "../../components/Modals/MessageModal";
import ProfileService from "../../services/profileService";
import { getUserBalance } from "../../global/getUserBalance";
import { getActiveWallets } from "../../utils/wallet";
// dsm
import { Button, Icon, Typography, Banner } from "@plum-xoxo/admin-dsm";
import AddEditRecipientCommon from "../../components/AddEditRecipientCommon";
import SelectCampaign from "../../components/SelectCampaign";
import EmailSmsAccordion from "../../components/EmailSmsAccordion";
import RewardsStepper from "../../components/RewardsStepper";
import OptionSideBar from "../../components/Sidebar/OptionSideBar";
import GetStartedDiy from "../../components/GetStartedDiy";

// constants
import { REWARD_TYPES } from "../../constants/bulkProcessConstant";
import { getSendRewardOptions } from "../../components/Sidebar/constants";
import { adminRole } from "../../constants/AppConstant";
import { app_path } from "config";
import { getContentWrapperClass } from "../../utils/header";
import { datas } from "../DiyLogin/components/Counrty";
import RecepientScrollDiv from "../../components/styled/RecipientScrollDiv";
import RecipientButtonDiv from "../../components/styled/RecipientButtonDiv";

const DEFAULT_BULK_UPLOAD_DATA = {
  reward_type: REWARD_TYPES.XOXO_POINTS,
  skip_filename_check: 0,
  attachments: "",
};

const DEFAULT_TEMPLATE = {
  album_id: 1,
  album_name: "Default",
  image_url:
    "http://xoxoday-testing.s3.amazonaws.com/store/template/default/e-gift-card-default.jpg",
  image_id: 1,
  company_id: "",
};

const DEFAULT_EMAIL_SUBJECT = "Congratulations! You have received a reward.";
const DEFAULT_EMAIL_HEADING = "Congratulations! You have received a reward.";
const DEFAULT_SMS_TEXT = "Congratulations! You have received reward points.";
const TODAY_DATE = moment().format("DD-MM-YYYY");
const XoxoPointsNew = (props) => {
  const { history, accountReducer, updateEmployeeDetails } = props;

  const {
    accountReducer: {
      employeeDetails: { employee_first_name = "" } = {},
      kybStatus = {},
      userBalance: { userBalance = 0, currencyCode = "INR" } = {},
      companyDetails: { company_primary_logo } = {},
      typeData: { role = 100, threshold_amount, used_amount } = {},
      platformSettings: { showCompanyBalance = false } = {},
      moduleAcl = [],
    } = {},
    bulkUploadData: {
      batchId = "",
      processing,
      uploading = false,
      uploadFileErr = "",
      batchProcessData: {
        insufficient_fund = 0,
        insufficient_threshold = 0,
        status = "",
        currentAmount: currentAmountBulk = 0,
        currentCount: currentCountBulk = 0,
        scheduledCount: scheduleCountBulk = 0,
        total_rows = 0,
        scheduledAmount: scheduleAmountBulk = 0,
      } = {},
    } = {},
    isFirstRewardSent = false,
  } = props;
  const domain = props?.accountReducer?.platformSettings?.urlPrefix;

  const [sendMode, setSendMode] = useState(["email"]);
  const [activeTab, setActiveTab] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [recipientType, setRecipientType] = useState(0);
  const [recipientData, setRecipientData] = useState([]);
  const [scheduleCount, setScheduleCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [activeSetting, setActiveSetting] = useState(0);
  const [error, setError] = useState([]);
  const [addAmount, setAddAmount] = useState(0);
  const [scheduleAmount, setScheduleAmount] = useState(0);
  const [nonScheduleCount, setNonScheduleCount] = useState(0);
  const [nonScheduledAmount, setNonScheduledAmount] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [emailLogo, setEmailLogo] = useState("");
  const [bulkSuccess, setBulkSuccess] = useState(false);
  // const [selectedSite, setSelectedSite] = useState({
  //   id: "0",
  //   name: "Global Rewards Catalogue",
  //   label: "Global Rewards Catalogue",
  //   status: 1,
  // });
  const [emailSubject, setEmailSubject] = useState(DEFAULT_EMAIL_SUBJECT);
  const [emailHeading, setEmailHeading] = useState(DEFAULT_EMAIL_HEADING);
  const [emailTitle, setEmailTitle] = useState("Congratulations!");
  const [smsText, setSmsText] = useState(DEFAULT_SMS_TEXT);
  const [startBulk, setStartBulk] = useState(false);
  const [showEditMessage, setShowEditMessage] = useState(true);
  const [showEgiftText, setShowEgiftText] = useState(true);
  const [templateId, setTemplateId] = useState(0);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [showThresholdError, setShowThresholdError] = useState(false);
  const [buttonText, setButtonText] = useState("Redeem Now");
  const [editColCampaign, setEditColCampaign] = useState(true);
  const [loader, setLoader] = useState(false);
  const [rechargedAmount, setRechargedAmount] = useState();
  const [getMenuLoader, setGetMenuLoader] = useState(false);
  const [cxml, setCxml] = useState("");
  const [subHeader, setSubHeader] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmSendBtnText, setConfirmBtnText] = useState("Send");
  const [confirmSendModal, setConfirmSendModal] = useState(false);
  const [actionModalMessage, setActionModalMessage] = useState("");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [verifyFile, setVerifyFile] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(
    JSON.parse(JSON.stringify(DEFAULT_TEMPLATE))
  );
  const [marketplaceError, setMarketplaceError] = useState("");
  const [uploadFileData, setUploadFileData] = useState(
    JSON.parse(JSON.stringify(DEFAULT_BULK_UPLOAD_DATA))
  );
  const [rechargeMaxLimit, setRechargeMaxLimit] = useState(0);
  const [rechargeMaxLimitError, setRechargeMaxLimitError] = useState(false);
  const [expiryMonth, setExpiryMonth] = useState({
    label: "12 months",
    value: 12,
  });
  const [whatsappText, setWhatsappText] = useState(
    "Congratulations! You have received a reward."
  );
  const [whatsappImage, setWhatsappImage] = useState("");
  const [whatsappAlbumImageId, setWhatsappAlbumImageId] = useState(0);
  const hasRun = useRef(false);

  const handleOnClick = () => {
    if (activeTab < 1) {
      setActiveTab(activeTab + 1);
      return;
    }
    if (kybStatus?.kyb_status === 0) {
      history.push(`/${app_path}/accounts/platform-preferences#submit-kyb`);
      return;
    }
    if (!domain) {
      setMarketplaceError(
        "Before sending rewards, it's essential to establish the domain first."
      );
      const el = document.getElementById("domainForm");
      setActiveSetting(2);
      el.scrollIntoView({ behavior: "smooth" });
      return;
    }
    if (recipientType === 0) {
      setVerifyFile(true);
    } else {
      if (activeTab === 1) handleSend(1);
    }
  };
  const handleBack = () => {
    if (activeTab >= 0) {
      setActiveTab((prevValue) => {
        if (prevValue === 0 && kybStatus.kyb_status !== 2) return -2;
        else if (prevValue === 0 && kybStatus.kyb_status === 2)
          return prevValue;
        else return prevValue - 1;
      });
    }
  };

  const smsTextModified = () => {
    //check for full stop in sms text
    let smsTextModified = smsText;
    if (smsTextModified) {
      smsTextModified = smsTextModified.trim();
      let lastChar = smsTextModified.substring(
        smsTextModified.length - 1,
        smsTextModified.length
      );
      if (lastChar != ".") {
        smsTextModified += ".";
      }
    }
    return smsTextModified;
  };

  const updateScheduleCount = (finalData) => {
    const kyb_status = props.accountReducer?.kybStatus?.kyb_status || 0;
    let schedule_count = 0;
    let nonSchedule_count = 0;
    let localNonScheduledAmount = 0;
    let localScheduleAmount = 0;

    finalData = finalData?.map((user) => {
      if (user.date && TODAY_DATE !== user.date) {
        const uDate = user?.date?.split("-");
        const uDateString = `${uDate[2]}-${uDate[1]}-${uDate[0]}`;
        const tDate = TODAY_DATE.split("-");
        const tDateString = `${tDate[2]}-${tDate[1]}-${tDate[0]}`;
        const userDate = new Date(uDateString);
        const todayDate = new Date(tDateString);
        if (userDate.getTime() < todayDate.getTime()) {
          user.date = TODAY_DATE;
        } else {
          schedule_count++;
          localScheduleAmount += user.total ? parseInt(user.total) : 0;
        }
      } else {
        localNonScheduledAmount += user.total ? parseInt(user.total) : 0;
      }
      return user;
    });

    nonSchedule_count = finalData.length - schedule_count;
    if (localNonScheduledAmount > userBalance) {
      setAddAmount(Math.ceil(localNonScheduledAmount - userBalance));
    }

    if (
      threshold_amount != null &&
      kyb_status !== 2 &&
      localNonScheduledAmount -
        (accountReducer?.userBalance?.userBalance || 0) >
        threshold_amount
    ) {
      setShowThresholdError(true);
    } else {
      setShowThresholdError(false);
    }
    setScheduleCount(schedule_count);
    setNonScheduleCount(nonSchedule_count);
    setNonScheduledAmount(localNonScheduledAmount);
    setScheduleAmount(localScheduleAmount);
    setRecipientData(finalData);
  };

  const updateEmailLogo = () => {
    setEmailLogo(
      company_primary_logo?.length > 0
        ? company_primary_logo
        : "https://res.cloudinary.com/dyyjph6kx/image/upload/v1639122457/store/Logo/xoxoday_logo_png.png"
    );
  };

  const handleSend = () => {
    let action_modal_message = "";
    let confirm_btn_text = "";
    if (scheduleCount > 0 && nonScheduleCount > 0) {
      action_modal_message =
        "You are sending Reward Points to " +
        nonScheduleCount +
        (nonScheduleCount > 1 ? " recipients" : " recipient") +
        " and scheduling for " +
        scheduleCount +
        (scheduleCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduleAmount + nonScheduledAmount).toLocaleString() +
        ". Do you want to proceed?";
      confirm_btn_text = "Yes, Proceed";
    } else if (nonScheduleCount > 0 && scheduleCount <= 0) {
      action_modal_message =
        "You are sending Reward Points to " +
        nonScheduleCount +
        (nonScheduleCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        nonScheduledAmount.toLocaleString() +
        ". Do you want to proceed" +
        "? ";
      confirm_btn_text = "Yes, Send";
    } else if (nonScheduleCount <= 0 && scheduleCount > 0) {
      action_modal_message =
        "You are scheduling Reward Points to " +
        +scheduleCount +
        (scheduleCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        scheduleAmount.toLocaleString() +
        ". Do you want to proceed" +
        "?";
      confirm_btn_text = "Yes, Schedule";
    } else {
      action_modal_message =
        "You are sending Reward Points to " +
        (scheduleCount + nonScheduleCount) +
        (scheduleCount + nonScheduleCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        nonScheduledAmount.toLocaleString() +
        "." +
        " Do you want to proceed" +
        "?";
      confirm_btn_text = "Yes, Send";
    }
    if (scheduleCount > 0) {
      action_modal_message = (
        <>
          <Typography>{action_modal_message}</Typography>
          <Typography className="mt-20">
            Please Note: To make sure reward is sent successfully on the
            scheduled date, ensure sufficient funds are available.{" "}
          </Typography>
        </>
      );
    }
    if (insufficient_fund === 1) {
      action_modal_message =
        "You don't have enough funds to send this reward. Add funds to the wallet  and upload the file again.";
      confirm_btn_text = "Add Funds";
    } else if (nonScheduledAmount - userBalance > 0) {
      confirm_btn_text = "Add funds and Send Reward";
      action_modal_message = (
        <>
          <Typography>{action_modal_message}</Typography>
          {nonScheduledAmount - userBalance > 0 && isFirstRewardSent && (
            <Banner
              className="my-4"
              color="warning"
              description={
                <Typography.HelperText>
                  <Typography.LabelText className="d-inline">
                    Alert :{" "}
                  </Typography.LabelText>
                  You are short of {currencyCode}{" "}
                  {parseFloat(nonScheduledAmount - userBalance).toLocaleString(
                    undefined,
                    { maximumFractionDigits: 2 }
                  )}{" "}
                  in your wallet. You can add the additional funds in the next
                  step.
                </Typography.HelperText>
              }
            />
          )}
        </>
      );
    }
    if (
      role === adminRole.admin &&
      !(insufficient_fund || insufficient_threshold)
    ) {
      setConfirmSendModal(true);
    } else if (role === adminRole.superAdmin) {
      setConfirmSendModal(true);
    }

    setActionModalMessage(action_modal_message);
    setConfirmBtnText(confirm_btn_text);
  };

  const handleReset = (onlyRecipient = 0) => {
    setRecipientData([]);
    setError({});
    setFinalTotal(0);
    setButtonText("Redeem Now");
    setSelectedTemplate(JSON.parse(JSON.stringify(DEFAULT_TEMPLATE)));
    setIsLoading(false);
    setConfirmSendModal(false);
    setShowMessageModal(false);
    setEmailSubject("Congratulations! You have received a reward."); // subject of email template
    setEmailHeading("Congratulations! You have received a reward."); // heading of email template
    setEmailTitle("Congratulations!");
    setScheduleCount(0);
    setNonScheduleCount(0);
    setNonScheduledAmount(0);
    setDisabled(true);
    setSuccessMessage("");
    setTemplateId(0);
    setTemplateLoading(false);
    setActiveTab(0);
    setSmsText(DEFAULT_SMS_TEXT);
    setRecipientType(0);
    setIsFileUploaded(false);
    props.resetBulkUploadData();
    // this.setState(
    //   {
    //     error: JSON.parse(JSON.stringify(ERROR_DATA)),
    //     showPaymentModal: false,
    //     uploadFileData: JSON.parse(JSON.stringify(DEFAULT_BULK_UPLOAD_DATA)),
    //     showSmsPreview: false,
    //     smsText: DEFAULT_SMS_TEXT,
    //     smsTextCount: DEFAULT_SMS_TEXT.length,
    //   },
    const fetchActivationSteps = () => {
      setIsLoading(true);
      ProfileService.getActivationSteps()
        .then((response) => {
          if (!response) {
            setIsLoading(false);
            updateEmailLogo();
          } else {
            props.history.push(`/${app_path}/dashboard`);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      setIsLoading(false);
    };
    () => {
      if (onlyRecipient == 5) {
        fetchActivationSteps();
      } else {
        updateEmailLogo();
      }
    };
  };

  const handleSoftReset = (onlyRecipient = 0) => {
    setRecipientData([]);
    setError({});
    setFinalTotal(0);
    setIsLoading(false);
    setConfirmSendModal(false);
    setShowMessageModal(false);
    setScheduleCount(0);
    setNonScheduleCount(0);
    setNonScheduledAmount(0);
    setDisabled(true);
    setSuccessMessage("");
    setTemplateLoading(false);
    setActiveTab(0);
    setRecipientType(0);
    setIsFileUploaded(false);
    props.resetBulkUploadData();
    // this.setState(
    //   {
    //     error: JSON.parse(JSON.stringify(ERROR_DATA)),
    //     showPaymentModal: false,
    //     uploadFileData: JSON.parse(JSON.stringify(DEFAULT_BULK_UPLOAD_DATA)),
    //     showSmsPreview: false,
    //     smsText: DEFAULT_SMS_TEXT,
    //     smsTextCount: DEFAULT_SMS_TEXT.length,
    //   },

    const fetchActivationSteps = () => {
      setIsLoading(true);
      ProfileService.getActivationSteps()
        .then((response) => {
          if (!response) {
            setIsLoading(false);
            updateEmailLogo();
          } else {
            props.history.push(`/${app_path}/dashboard`);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      setIsLoading(false);
    };

    () => {
      if (onlyRecipient == 5) {
        fetchActivationSteps();
      } else {
        updateEmailLogo();
      }
    };
  };

  const getMenu = () => {
    setGetMenuLoader(true);
    ProfileService.getMenu()
      .then((response) => {
        setGetMenuLoader(false);
        if (response && response.success === 1) {
          let data = response.data || {};
          if (data.threshold_amount) {
            data.threshold_amount =
              Math.round(data.threshold_amount * 100) / 100;
          }
          if (data.used_amount) {
            data.used_amount = Math.round(data.used_amount * 100) / 100;
          }
          if (data.admin_balance) {
            data.admin_balance = Math.round(data.admin_balance * 100) / 100;
          }
          props.updateUserAndCompanyType(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const proceedToPayment = (isRetry = false) => {
    const {
      accountReducer: { companyDetails = {} },
    } = props;
    const moduleAclArray =
      accountReducer?.moduleAcl?.map((item) => item.module_id) || [];

    const activeWallets = getActiveWallets(moduleAclArray, accountReducer);
    const companyRecharge =
      activeWallets.length === 1
        ? activeWallets[0].callBack.company_recharge
        : 2;
    const { currencySymbol } = props;
    const isCompanyAddressPresent =
      accountReducer?.companyDetails?.company_address1;
    props.history.push({
      pathname: `/${app_path}/payment`,
      state: JSON.stringify({
        amount: Math.ceil(
          parseFloat(nonScheduledAmount - userBalance).toFixed(2)
        ),
        companyDetails: companyDetails,
        product_type: 4,
        company_recharge: companyRecharge,
        currencySymbol: currencySymbol,
        redirectPage: `/${app_path}/xoxo-points/`,
        nonScheduleCount: nonScheduleCount,
      }),
    });
  };

  const createPoint = () => {
    if (nonScheduledAmount - userBalance > 0) {
      proceedToPayment();
      return;
    }
    const { updateUserBalance } = props;

    const {
      accountReducer: {
        platformSettings: { messaging: { sendSmsSwitch = 1 } = {} } = {},
      } = {},
    } = props;
    const recipient_data = [];

    // let schedulerCount = 0
    recipientData &&
      recipientData.map((item, index) => {
        // if(item && item.date ){
        //     schedulerCount++;
        // }
        let sendDate =
          item.date && item.date !== moment().format("DD-MM-YYYY")
            ? item.date
            : "";
        item.name && (item.email || item.to_phone_number) && item.amount
          ? recipient_data.push({
              to_name: item.name,
              to_email: item.email || "",
              amount: parseInt(item.amount),
              phone_code:
                (item.to_phone_number &&
                  item.to_phone_code &&
                  item.to_phone_code.phonecode) ||
                "",
              phone_number: item.to_phone_number,
              user_message: item.user_message,
              notes: item.notes || "",
              schedule_date: sendDate,
            })
          : (error = true);
      });
    setIsLoading(true);
    setDisabled(true);

    let mail_details = {
      album_img_id: selectedTemplate.image_id,
      logo: emailLogo && emailLogo.length > 250 ? "" : emailLogo,
      heading: emailTitle,
      subject: emailSubject,
      message: emailHeading,
      redeem_button_text: buttonText,
    };

    let whatsapp_details = {
      album_img_id: `${whatsappAlbumImageId}`,
      text: whatsappText,
    };

    let recipients_details = {
      validate: 0,
      register_user: 1,
      recipients: recipient_data,
      schedule_type: 2, // schedule type 2 is for xoxo point and for xoxo code it is 1
      mode_of_communication: sendMode?.join(","),
    };
    // if (sendMode.includes("email")) {
    recipients_details["mail_details"] = mail_details;
    // }

    if (sendMode?.includes("sms") && sendSmsSwitch) {
      recipients_details["sms_data"] = {
        text: smsTextModified(),
      };
    }

    if (sendMode?.includes("whatsapp")) {
      recipients_details["whatsapp_details"] = whatsapp_details;
    }

    const request_data = {
      query: "storesAdmin.mutation.addBalance",
      tag: "storeAdmin",
      variables: {
        recipients_details,
      },
    };

    makeRequestAuth(request_data, function (response) {
      if (response && response.data && response.data.addBalance) {
        if (response.data.addBalance.error === false) {
          let sub_header = "";
          let success_message = "Rewards sent successfully!";
          sub_header = "";
          if (scheduleCount > 0 && nonScheduleCount > 0) {
            sub_header = `You have successfully sent Reward Points to ${nonScheduleCount} ${
              nonScheduleCount > 1 ? "recipients" : "recipient"
            } and scheduled to ${scheduleCount} ${
              scheduleCount > 1 ? "recipients" : "recipient"
            } worth ${currencyCode} ${scheduleAmount + nonScheduledAmount}.`;
            success_message = "Rewards Sent and Scheduled Successfully!";
          } else if (nonScheduleCount > 0 && scheduleCount <= 0) {
            sub_header = `You have successfully sent Reward Points to ${nonScheduleCount} ${
              nonScheduleCount > 1 ? "recipients" : "recipient"
            } worth ${currencyCode} ${nonScheduledAmount}.`;
          } else if (nonScheduleCount <= 0 && scheduleCount > 0) {
            sub_header = `You have successfully scheduled Reward Points to ${scheduleCount} ${
              scheduleCount > 1 ? "recipients" : "recipient"
            } worth ${currencyCode} ${scheduleAmount}.`;
            success_message = "Rewards Scheduled Successfully!";
          } else {
            sub_header =
              "You have successfully sent Reward Points to all recipients";
          }
          let subHeaderComponent = (
            <>
              <Typography component="div" className="mb-0">
                {sub_header}
              </Typography>
              <br />
              <Typography>
                You can view details for this rewarding instance under Reports.
              </Typography>
            </>
          );
          setConfirmSendModal(false);
          setSuccessMessage(success_message);
          setRecipientData([]);
          setSubHeader(subHeaderComponent);
          setShowMessageModal(true);

          updateEmailLogo();
          getUserBalance(updateUserBalance);
          getMenu();
        } else if (response.data.addBalance.errCode === "KYB_NOT_VERIFIED") {
          // this.setState({
          //   openKybErrorModal: true,
          // });
        } else {
          NotificationManager.error(
            response.data.addBalance.message[0]
              ? response.data.addBalance.message[0]
              : "Something Went Wrong",
            "Error"
          );
        }
      } else {
        NotificationManager.error("Something Went Wrong", "Error");
      }
      setConfirmSendModal(false);
      setIsLoading(false);
      setDisabled(false);
    });
  };
  const sendToReports = () => {
    const {
      accountReducer: {
        typeData: { walletCompany = 0 },
      },
    } = props;
    handleReset();
    const redirectLink = walletCompany
      ? `/${app_path}/reports/xoxo-token-report`
      : `/${app_path}/reports/voucher-recharge`;
    props.history.push({
      pathname: redirectLink,
      activeTab: "2",
      title: "reward-points",
    });
  };

  useEffect(() => {
    if (processing == 5) {
      setConfirmSendModal(false);
      setIsLoading(false);
    }
  }, [processing]);

  useEffect(() => {
    updateEmailLogo();
    const newState = JSON.parse(sessionStorage.getItem("xoxoPointsState"));
    if (newState?.recipientData?.length > 0) {
      setRecipientType(1);
    } else {
      setRecipientType(0);
    }
    if (newState) {
      setRecipientData(newState?.recipientData);
      setSelectedTemplate(newState?.selectedTemplate);
      setSubHeader(newState?.subHeader);
      setEmailLogo(newState?.emailLogo);
      setEmailSubject(newState?.emailSubject);
      setEmailHeading(newState?.emailHeading);
      setEmailTitle(newState?.emailTitle);
      setButtonText(newState?.buttonText);
      setScheduleCount(newState?.scheduleCount);
      setNonScheduleCount(newState?.nonScheduleCount);
      setSmsText(newState?.smsText);
      updateScheduleCount(newState?.recipientData);
      setSendMode(newState?.sendMode);
    }
  }, []);

  useEffect(() => {
    window.history.replaceState({}, "");
    const batch_id = sessionStorage.getItem("batch_id");
    if (props.location.state !== undefined && !hasRun.current) {
      const data = JSON.parse(props.location.state);
      if (data && data.paymentStatus) {
        if (data.paymentStatus === "success" || data.paymentStatus === "fail") {
          if (data.paymentStatus === "success") {
            if (batch_id) {
              // setIsLoading(true);
              // setStartBulk(true);
              // setRechargedAmount(data.amount);
              // sessionStorage.removeItem("batch_id");
              // props.history.replace({
              //   pathname: props.location.pathname,
              //   state: undefined,
              // });
            } else if (recipientData.length) {
              createPoint();
              setRechargedAmount(data.amount);
              props.history.replace({
                pathname: props.location.pathname,
                state: undefined,
              });
            }
          } else {
            NotificationManager.error("Payment Failed.", "Error");
            props.history.replace({
              pathname: props.location.pathname,
              state: undefined,
            });
          }
        }
      }
    }
    sessionStorage.removeItem("batch_id");
  }, [recipientData]);

  useEffect(() => {
    sessionStorage.setItem(
      "xoxoPointsState",
      JSON.stringify({
        emailLogo,
        selectedTemplate,
        emailHeading,
        emailTitle,
        emailSubject,
        disabled,
        scheduleCount,
        nonScheduleCount,
        recipientData,
        smsText,
        sendMode,
      })
    );
  }, [
    emailLogo,
    selectedTemplate,
    emailHeading,
    emailTitle,
    emailSubject,
    disabled,
    scheduleCount,
    nonScheduleCount,
    recipientData,
    smsText,
    sendMode,
  ]);

  useEffect(() => {
    datas;
    const rechargeMaxLimitValue =
      datas.find((item) => item.code == currencyCode)?.rechargeMaxLimit || 0;
    if (
      rechargeMaxLimitValue &&
      parseFloat(nonScheduledAmount - userBalance).toFixed() >
        rechargeMaxLimitValue
    ) {
      setDisabled(true);
      setActiveTab(0);
      setRechargeMaxLimit(rechargeMaxLimitValue);
      setRechargeMaxLimitError(true);
    } else {
      setRechargeMaxLimitError(false);
    }
  }, [currencyCode, nonScheduledAmount]);

  useEffect(() => {
    if (!batchId) return;
    sessionStorage.setItem("batch_id", batchId);
  }, [batchId]);

  parseFloat(nonScheduledAmount - userBalance).toFixed() > 0;

  useEffect(() => {
    if (
      role === adminRole.admin &&
      (insufficient_fund || insufficient_threshold)
    ) {
      setDisabled(true);
      setActiveTab(0);
    }
  }, [insufficient_fund, insufficient_threshold]);

  useEffect(() => {
    if (
      !bulkSuccess &&
      (status === "VALIDATION_SUCCESS" || status === "FAILURE")
    ) {
      handleSend(1);
    }
    setBulkSuccess(false);
  }, [nonScheduledAmount, scheduleAmount, scheduleCount, nonScheduleCount]);

  useEffect(() => {
    if (status === "VALIDATION_SUCCESS") {
      setNonScheduleCount(currentCountBulk);
      setScheduleCount(scheduleCountBulk);
      setScheduleAmount(scheduleAmountBulk);
      setNonScheduledAmount(currentAmountBulk);
    } else if (
      status === "VALIDATION_FAILURE" ||
      uploadFileErr === "PBB12017" ||
      uploadFileErr !== ""
    ) {
      setActiveTab(0);
      setDisabled(true);
      setIsFileUploaded(false);
    } else if (status === "FAILURE") {
      setNonScheduleCount(currentCountBulk);
      setScheduleCount(scheduleCountBulk);
      setScheduleAmount(scheduleAmountBulk);
      setNonScheduledAmount(currentAmountBulk);
    }
  }, [status, uploading, uploadFileErr]);

  useEffect(() => {
    if (!isFileUploaded) resetBulkUploadData();
  }, [isFileUploaded]);

  useEffect(() => {
    if (recipientType === 1 && recipientData.length > 0) setDisabled(false);
    else if (recipientType === 1 && recipientData.length === 0)
      setDisabled(true);
    else if (recipientType === 0 && isFileUploaded) setDisabled(false);

    if (
      (nonScheduledAmount - userBalance > 0 ||
        showThresholdError ||
        nonScheduledAmount + used_amount > threshold_amount ||
        insufficient_fund ||
        insufficient_threshold) &&
      role === adminRole.admin
    )
      setDisabled(true);
  }, [
    recipientType,
    recipientData,
    isFileUploaded,
    nonScheduledAmount,
    userBalance,
  ]);

  useEffect(() => {
    if (activeTab === 1) {
      setActiveSetting(2);
    }
  }, [activeTab]);
  const dismissKyb = JSON.parse(sessionStorage.getItem("dismissKyb")) || false;
  return (
    <>
      <OptionSideBar
        title="Send Rewards"
        options={getSendRewardOptions(moduleAcl)}
        userBalance={userBalance}
        currencyCode={currencyCode}
        showCompanyBalance={showCompanyBalance}
        accountReducer={props.accountReducer}
        isFirstRewardSent={isFirstRewardSent}
      />
      <div className={`${getContentWrapperClass(props)} pb-0`}>
        <div className="d-flex w-100">
          <div
            className="d-flex flex-column w-100 mr-32"
            style={{
              height:
                (!dismissKyb && !isFirstRewardSent) ||
                (accountReducer?.mfaData?.res?.length &&
                  accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1)
                  ? "calc(100vh - 120px)"
                  : "calc(100vh - 80px)",
            }}
          >
            <RecepientScrollDiv>
              <Typography.H2>
                {kybStatus?.kyb_status !== 2 && activeTab === -2
                  ? `Welcome ${employee_first_name || ""},`
                  : "Send Reward Points"}
              </Typography.H2>
              {role == adminRole.admin &&
              threshold_amount != null &&
              !(nonScheduledAmount - userBalance > 0 || insufficient_fund) &&
              (nonScheduledAmount + used_amount > threshold_amount ||
                insufficient_threshold) ? (
                <Banner
                  className="mt-12"
                  iconName={null}
                  color="error"
                  description={
                    <>
                      <Typography.LabelText
                        color="red"
                        shade="c200"
                        component={"span"}
                      >
                        Alert:
                      </Typography.LabelText>{" "}
                      <Typography.HelperText component={"span"}>
                        The reward value exceeds your available threshold limit.
                        Please contact your super admin for assistance.
                      </Typography.HelperText>
                    </>
                  }
                />
              ) : null}
              {(nonScheduledAmount - userBalance > 0 || insufficient_fund) &&
              role === adminRole.admin ? (
                <Banner
                  className="mt-12"
                  iconName={null}
                  color="error"
                  description={
                    <>
                      <Typography.LabelText
                        color="red"
                        shade="c200"
                        component={"span"}
                      >
                        Alert:
                      </Typography.LabelText>{" "}
                      <Typography.HelperText component={"span"}>
                        You have insufficient funds in the account wallet.
                        Please contact your super admin for assistance.
                      </Typography.HelperText>
                    </>
                  }
                />
              ) : null}
              <div className={`${activeTab === -2 ? "" : "d-none"}`}>
                <GetStartedDiy
                  kybStatus={kybStatus?.kyb_status}
                  rewardType={1}
                  history={props.history}
                  setActiveTab={setActiveTab}
                />
              </div>
              <div className={`${activeTab === 0 ? "" : "d-none"}`}>
                <AddEditRecipientCommon
                  smsText={smsText}
                  currencyCode={currencyCode}
                  role={role}
                  rewardType={1}
                  accountReducer={accountReducer}
                  history={history}
                  recipientType={recipientType}
                  setRecipientType={setRecipientType}
                  recipientData={recipientData}
                  setRecipientData={setRecipientData}
                  scheduleAmount={scheduleAmount}
                  nonScheduledAmount={nonScheduledAmount}
                  setFinalTotal={setFinalTotal}
                  finalTotal={finalTotal}
                  uploadFileData={uploadFileData}
                  setUploadFileData={setUploadFileData}
                  setError={setError}
                  isFileUploaded={isFileUploaded}
                  setIsFileUploaded={setIsFileUploaded}
                  selectedTemplate={selectedTemplate}
                  emailLogo={emailLogo}
                  emailHeading={emailHeading}
                  emailTitle={emailTitle}
                  emailSubject={emailSubject}
                  updateScheduleCount={updateScheduleCount}
                  setDisabled={setDisabled}
                  verifyFile={verifyFile}
                  setVerifyFile={setVerifyFile}
                  startBulk={startBulk}
                  setStartBulk={setStartBulk}
                  sendMode={sendMode}
                  setSendMode={setSendMode}
                  nonScheduleCount={nonScheduleCount}
                  handleReset={handleSoftReset}
                  setBulkSuccess={setBulkSuccess}
                  setNonScheduledAmount={setNonScheduledAmount}
                  setNonScheduleCount={setNonScheduleCount}
                  setScheduleAmount={setScheduleAmount}
                  setScheduleCount={setScheduleCount}
                  rechargeMaxLimitError={rechargeMaxLimitError}
                  rechargeMaxLimit={rechargeMaxLimit}
                  buttonText={buttonText}
                  whatsappText={whatsappText}
                  whatsappAlbumImageId={whatsappAlbumImageId}
                />
              </div>
              <div className={`${activeTab === 1 ? "" : "d-none"}`}>
                <SelectCampaign
                  rewardType={1}
                  templateLoading={templateLoading}
                  setTemplateLoading={setTemplateLoading}
                  emailHeading={emailHeading}
                  setEmailHeading={setEmailHeading}
                  setEmailTitle={setEmailTitle}
                  emailSubject={emailSubject}
                  setEmailSubject={setEmailSubject}
                  emailLogo={emailLogo}
                  setEmailLogo={setEmailLogo}
                  selectedTemplate={selectedTemplate}
                  setSelectedTemplate={setSelectedTemplate}
                  DEFAULT_TEMPLATE={DEFAULT_TEMPLATE}
                  history={props.history}
                  activeSetting={activeSetting}
                  kybStatus={kybStatus}
                  domain={domain}
                  firstRewardSent={isFirstRewardSent}
                  updateEmployeeDetails={updateEmployeeDetails}
                  marketplaceError={marketplaceError}
                  setMarketplaceError={setMarketplaceError}
                  whatsappImage={whatsappImage}
                  setWhatsappImage={setWhatsappImage}
                  whatsappText={whatsappText}
                  setWhatsappText={setWhatsappText}
                  whatsappAlbumImageId={whatsappAlbumImageId}
                  setWhatsappAlbumImageId={setWhatsappAlbumImageId}
                  {...props}
                />
                <EmailSmsAccordion
                  recipientData={recipientData}
                  rewardType={1}
                  smsText={smsText}
                  expiryMonth={expiryMonth}
                  selectedTemplate={selectedTemplate}
                  emailSubject={emailSubject}
                  emailHeading={emailHeading}
                  emailTitle={emailTitle}
                  setEmailTitle={setEmailTitle}
                  emailLogo={emailLogo}
                  showEditMessage={showEditMessage}
                  showEgiftText={showEgiftText}
                  company_primary_logo={emailLogo}
                  setSmsText={setSmsText}
                  setSelectedTemplate={setSelectedTemplate}
                  setEmailSubject={setEmailSubject}
                  setEmailHeading={setEmailHeading}
                  setEmailLogo={setEmailLogo}
                  currencyCode={currencyCode}
                  buttonText={buttonText}
                  setButtonText={setButtonText}
                  setShowEgiftText={setShowEgiftText}
                  setShowEditMessage={setShowEditMessage}
                  setEditColCampaign={setEditColCampaign}
                  setLoader={setLoader}
                  setIsLoading={setIsLoading}
                  activeSetting={activeSetting}
                  sendMode={sendMode}
                  accountReducer={accountReducer}
                  firstRewardSent={isFirstRewardSent}
                  whatsappText={whatsappText}
                  setWhatsappText={setWhatsappText}
                  whatsappAlbumImageId={whatsappAlbumImageId}
                  setWhatsappAlbumImageId={setWhatsappAlbumImageId}
                  whatsappImage={whatsappImage}
                  setWhatsappImage={setWhatsappImage}
                />
              </div>
            </RecepientScrollDiv>
            {activeTab !== -2 && (
              <RecipientButtonDiv
                className="d-flex"
                kybStatus={kybStatus}
                activeTab={activeTab}
              >
                {(activeTab !== 0 || kybStatus !== 2) && (
                  <Button
                    variant="outlined"
                    onClick={handleBack}
                    startIcon={
                      <Icon iconName="LeftArrow" size={18} fill="white" />
                    }
                    style={{ width: "160px" }}
                  >
                    Back
                  </Button>
                )}
                <Button
                  disabled={
                    isLoading ||
                    disabled ||
                    ((kybStatus?.kyb_status == 1 ||
                      kybStatus?.kyb_status == 3 ||
                      kybStatus?.kyb_status == 5) &&
                      activeTab === 1) ||
                    (emailSubject.trim() === "" && activeTab === 1) ||
                    rechargeMaxLimitError ||
                    (role === adminRole.admin &&
                      (nonScheduledAmount - userBalance > 0 ||
                        showThresholdError ||
                        nonScheduledAmount + used_amount > threshold_amount ||
                        insufficient_fund ||
                        insufficient_threshold))
                  }
                  variant="fill"
                  endIcon={
                    activeTab !== 1 ? (
                      <Icon iconName="RightArrow" size={18} fill="white" />
                    ) : null
                  }
                  color="primary"
                  className="w-100"
                  onClick={handleOnClick}
                  loading={isLoading}
                >
                  {" "}
                  {activeTab === 1
                    ? kybStatus?.kyb_status === 0
                      ? "Verify Business Details to Send Rewards"
                      : "Send Rewards"
                    : "Next"}
                </Button>
              </RecipientButtonDiv>
            )}
          </div>
          <RewardsStepper
            rewardType={1}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            recipientType={recipientType}
            recipientData={recipientData}
            setActiveSetting={setActiveSetting}
            isFileUploaded={isFileUploaded}
            status={status}
            kybStatus={kybStatus.kyb_status}
          />
        </div>
        {confirmSendModal && (
          <ActionModal
            header="Are You Sure?"
            cancelBtnText="No, Cancel"
            actionModalSubHeader={actionModalMessage}
            callbackMethod={() => {
              setConfirmSendModal(false);
              setActiveTab(0);
              if (recipientType === 0) {
                handleReset();
                setBulkSuccess(true);
              }
            }}
            minWidth="400px"
            buttonText={confirmSendBtnText}
            loading={isLoading}
            actionHandler={() => {
              if (recipientType === 1) createPoint();
              else {
                if (insufficient_fund === 1) {
                  proceedToPayment();
                } else {
                  setIsLoading(true);
                  setStartBulk(true);
                }
              }
            }}
          />
        )}
        {showMessageModal && (
          <MessageModal
            header={
              <>
                <Icon
                  color="success"
                  iconName="PlumCheckbox"
                  size="xl"
                  shade="c04"
                  className="mb-12"
                />
                <Typography.H2>{successMessage}</Typography.H2>
              </>
            }
            onClose={() => handleReset(5)}
            cxml={cxml}
            accountReducer={props.accountReducer}
            disableCloseButton={false}
            subHeader={subHeader}
            callbackMethod={() => {
              handleReset(5);
            }}
            footerAction={sendToReports}
            footerText={"View Reports"}
            image={"/admin/img/svg-icons/successAnimation.gif"}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    bulkProcessReducer: { bulkUploadData = {}, bulkProcessData = {} },
  } = state;
  return {
    bulkUploadData,
    bulkProcessData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadFileDataV1: (params) => uploadFileDataV1(params),
      resetBulkUploadData: () => resetBulkUploadData(),
      updateBulkUploadFileUploader: (param) =>
        updateBulkUploadFileUploader(param),
      updateBulkUploadFormData: (param) => updateBulkUploadFormData(param),
      startBulkProcess: (param, bulkProcessData, fileName) =>
        startBulkProcess(param, bulkProcessData, fileName),
      updateBulkProcessing: (param) => updateBulkProcessing(param),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(XoxoPointsNew);
